import * as IoC from 'inversify';
import { CommandHandlerSymbol, CommandHandlerFactorySymbol } from './command';
import { QueryHandlerFactorySymbol, QueryHandlerSymbol } from './query';

export function registerCommand<T>(name: string,
                                   handler: IoC.interfaces.ServiceIdentifier<T>,
                                   bind: IoC.interfaces.Bind) {

  bind(CommandHandlerSymbol).
        toDynamicValue((c) => c.container.get(handler)).whenTargetNamed(name);
  bind(handler).toSelf();
}

export function registerQuery<T>(name: string,
                                 handler: IoC.interfaces.ServiceIdentifier<T>,
                                 bind: IoC.interfaces.Bind) {

  bind(QueryHandlerSymbol).
        toDynamicValue((c) => c.container.get(handler)).whenTargetNamed(name);
  bind(handler).toSelf();
}

export function registerCommandHandlerFactory(bind: IoC.interfaces.Bind) {
  bind(CommandHandlerFactorySymbol)
    .toFactory((c) => (name: string) => c.container.getNamed(CommandHandlerSymbol, name));
}

export function registerQueryHandlerFactory(bind: IoC.interfaces.Bind) {
  bind(QueryHandlerFactorySymbol)
    .toFactory((c) => (name: string) => c.container.getNamed(QueryHandlerSymbol, name));
}
